import React from 'react';
import { createRoot } from 'react-dom/client';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './assets/css/tailwind.css';
import App from './App';
import { initializeShellPreferences } from './Modules/Core/Components/TopBar/shellPreferences';

// Theme initializer: apply .dark based on user preference or system setting
(function initTheme() {
  try {
    const stored = localStorage.getItem('theme'); // 'dark' | 'light' | null
    const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    const resolvedTheme =
      stored === 'dark' || stored === 'light' || stored === 'system'
        ? stored
        : 'dark';
    const initial =
      resolvedTheme === 'system' ? (prefersDark ? 'dark' : 'light') : resolvedTheme;
    document.documentElement.classList.toggle('dark', initial === 'dark');

    // Keep in sync with OS if no explicit user preference is saved
    if (window.matchMedia) {
      const media = window.matchMedia('(prefers-color-scheme: dark)');
      const onChange = (e) => {
        const nextStored = localStorage.getItem('theme');
        if (!nextStored || nextStored === 'system') {
          document.documentElement.classList.toggle('dark', e.matches);
        }
      };
      // modern browsers
      if (media.addEventListener) {
        media.addEventListener('change', onChange);
      } else if (media.addListener) {
        // fallback
        media.addListener(onChange);
      }
    }
  } catch (e) {
    document.documentElement.classList.add('dark');
  }
})();

initializeShellPreferences();

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();
